import React, { ReactNode } from 'react'

interface RenderIfProps {
  condition: any
  children: ReactNode
}

const RenderIf: React.FC<RenderIfProps> = ({ condition, children }) => {
  return condition ? <>{children}</> : null
}

export default RenderIf
